import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function LawDashboard() {
  const navigate = useNavigate();
  const [stats, setStats] = useState({ caseCount: 0, todayLogs: 0, weekLogs: 0 });
  const [todaySummary, setTodaySummary] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const token = localStorage.getItem('notes_token');
      const headers = { 'x-token': token };

      // 获取案件数
      const casesRes = await fetch(`${API_URL}/api/law/cases`, { headers });
      const cases = await casesRes.json();
      
      // 获取今日日志
      const today = new Date().toISOString().split('T')[0];
      const logsRes = await fetch(`${API_URL}/api/law/logs?date=${today}`, { headers });
      const todayLogs = await logsRes.json();
      
      // 获取本周日志
      const weekStart = new Date();
      weekStart.setDate(weekStart.getDate() - weekStart.getDay() + 1);
      const weekStartStr = weekStart.toISOString().split('T')[0];
      const weekLogsRes = await fetch(`${API_URL}/api/law/logs?startDate=${weekStartStr}&endDate=${today}`, { headers });
      const weekLogs = await weekLogsRes.json();

      setStats({
        caseCount: Array.isArray(cases) ? cases.length : 0,
        todayLogs: Array.isArray(todayLogs) ? todayLogs.length : 0,
        weekLogs: Array.isArray(weekLogs) ? weekLogs.length : 0,
      });

      // 获取日报摘要
      try {
        const reportRes = await fetch(`${API_URL}/api/law/report/daily?date=${today}`, { headers });
        const report = await reportRes.json();
        setTodaySummary(report.summary || '');
      } catch {}
    } catch (e) {
      console.error('加载法律模块数据失败:', e);
    } finally {
      setLoading(false);
    }
  };

  const quickActions = [
    { icon: '📋', title: '案件管理', desc: '管理案件台账、状态跟踪', path: '/law/cases', color: '#1a73e8' },
    { icon: '📝', title: '工作记录', desc: '快速记录日常工作', path: '/law/logs', color: '#34a853' },
    { icon: '📊', title: '工作日报', desc: '生成日报/周报/年报', path: '/law/report', color: '#ea4335' },
    { icon: '⚖️', title: '法务助手', desc: '法律咨询、法规检索', path: '/legal-qa', color: '#9334e6' },
  ];

  return (
    <div className="law-dashboard">
      <div className="law-header">
        <h2 style={{ margin: 0, fontSize: 22 }}>⚖️ 法律AI工具箱</h2>
        <p style={{ margin: '4px 0 0', color: '#666', fontSize: 14 }}>
          案件管理 · 工作记录 · 智能报告 · 法律咨询
        </p>
      </div>

      {/* 快捷入口 */}
      <div className="law-quick-actions" style={{
        display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 12, marginTop: 20
      }}>
        {quickActions.map(action => (
          <div key={action.path}
            onClick={() => navigate(action.path)}
            style={{
              background: 'white',
              border: '1px solid #e8e8e8',
              borderRadius: 12,
              padding: 16,
              cursor: 'pointer',
              transition: 'all 0.2s',
              boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
            }}
            onMouseEnter={e => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'}
            onMouseLeave={e => e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.06)'}
          >
            <div style={{ fontSize: 32, marginBottom: 8 }}>{action.icon}</div>
            <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 4 }}>{action.title}</div>
            <div style={{ fontSize: 12, color: '#888' }}>{action.desc}</div>
          </div>
        ))}
      </div>

      {/* 今日概览 */}
      <div className="law-overview" style={{
        background: 'white',
        borderRadius: 12,
        padding: 20,
        marginTop: 20,
        border: '1px solid #e8e8e8'
      }}>
        <h3 style={{ margin: '0 0 16px', fontSize: 16, color: '#333' }}>📈 今日概览</h3>
        {loading ? (
          <div style={{ color: '#999', fontSize: 14 }}>加载中...</div>
        ) : (
          <>
            <div className="law-stats" style={{
              display: 'flex', gap: 24, marginBottom: 16
            }}>
              <div style={{ textAlign: 'center', flex: 1, padding: '12px 0', background: '#f0f7ff', borderRadius: 8 }}>
                <div style={{ fontSize: 28, fontWeight: 700, color: '#1a73e8' }}>{stats.caseCount}</div>
                <div style={{ fontSize: 13, color: '#666' }}>在办案件</div>
              </div>
              <div style={{ textAlign: 'center', flex: 1, padding: '12px 0', background: '#e6f4ea', borderRadius: 8 }}>
                <div style={{ fontSize: 28, fontWeight: 700, color: '#34a853' }}>{stats.todayLogs}</div>
                <div style={{ fontSize: 13, color: '#666' }}>今日记录</div>
              </div>
              <div style={{ textAlign: 'center', flex: 1, padding: '12px 0', background: '#fef7e0', borderRadius: 8 }}>
                <div style={{ fontSize: 28, fontWeight: 700, color: '#ea4335' }}>{stats.weekLogs}</div>
                <div style={{ fontSize: 13, color: '#666' }}>本周记录</div>
              </div>
            </div>
            {todaySummary && (
              <div className="law-summary" style={{
                background: '#fafafa',
                borderRadius: 8,
                padding: 12,
                fontSize: 13,
                lineHeight: 1.6,
                whiteSpace: 'pre-wrap',
                color: '#333'
              }}>
                {todaySummary}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
